import { render, staticRenderFns } from "./traitement-en-cours-historique.html?vue&type=template&id=f2c68e32&scoped=true&external"
import script from "./traitement-en-cours-historique.js?vue&type=script&lang=js&external"
export * from "./traitement-en-cours-historique.js?vue&type=script&lang=js&external"
import style0 from "./traitement-en-cours-historique.scss?vue&type=style&index=0&id=f2c68e32&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c68e32",
  null
  
)

export default component.exports